export const hasReservationSummaryData = (data) => Boolean(data) && (
    Number(data.thisMonth) > 0
    || Number(data.thisWeek) > 0
    || Number(data.today?.count) > 0
    || Boolean(data.nextReservation)
    || Number(data.pendingDeposit) > 0
);
